import React from "react";
import { ConnectionsCard } from "@/agent/connections/ConnectionsCard";
import { canUseAgent } from "@/auth/capabilities";
import AiAppsCard from "@/components/settings/AiAppsCard";
import AssistantModelCard from "@/components/settings/AssistantModelCard";
import ChangePasswordForm from "@/components/settings/ChangePasswordForm";
import ProfileAccountForm from "@/components/settings/ProfileAccountForm";
import ProfileOrganizationsCard from "@/components/settings/ProfileOrganizationsCard";
import { useCurrentUser } from "@/hooks/useCurrentUser";

const Profile: React.FC = () => {
  const { user } = useCurrentUser();
  return (
    <div>
      <h1 className="mb-8 text-3xl font-semibold tracking-tight">Profile</h1>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <ProfileAccountForm />
        <ChangePasswordForm />
        <ProfileOrganizationsCard />
        {canUseAgent(user) && (
          <>
            <AssistantModelCard />
            <AiAppsCard />
          </>
        )}
        {canUseAgent(user) && (
          <div className="min-w-0 md:col-span-2">
            <ConnectionsCard />
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
